import React from "react";
import { Route, Switch, NavLink, Redirect } from "react-router-dom";
import PropTypes from "prop-types";

import HasPermission from "hoc/RbacCTA";

const TabWithRoute = ({ children: tabRouteChildren, redirectUrl, match }) => {
  const { path: basePath, url: baseUrl } = match;
  let tabRoutes;

  // check if children is array (multiple children) or object (single child)
  if (tabRouteChildren.length) {
    tabRoutes = tabRouteChildren.map((tabRouteComponent) => {
      if (!tabRouteComponent.props?.resourcePath) return;

      const {
        props: { resourcePath, render },
      } = tabRouteComponent;

      // eslint-disable-next-line consistent-return
      return (
        <Route
          key={resourcePath}
          path={`${basePath}/${resourcePath}`}
          render={() => <div className="tab-route-content">{render}</div>}
        />
      );
    });
  } else {
    const {
      props: { resourcePath, render },
    } = tabRouteChildren;

    tabRoutes = (
      <Route
        key={resourcePath}
        path={`${basePath}/${resourcePath}`}
        render={() => <div className="tab-route-content px-3">{render}</div>}
      />
    );
  }

  const redirectRoute = redirectUrl ? (
    <Route exact path={basePath}>
      <Redirect to={`${baseUrl}/${redirectUrl}`} />
    </Route>
  ) : null;

  return (
    <div className="tab-route-container shadow-sm d-flex flex-column">
      <div className="tab-route-header text-secondary">{tabRouteChildren}</div>
      <Switch>
        {redirectRoute}
        {tabRoutes}
      </Switch>
    </div>
  );
};

TabWithRoute.defaultProps = {
  redirectUrl: undefined,
};

TabWithRoute.propTypes = {
  children: PropTypes.arrayOf(
    PropTypes.objectOf({
      props: PropTypes.objectOf({
        resourcePath: PropTypes.string,
        render: PropTypes.objectOf({
          props: PropTypes.objectOf({
            parentActiveStatus: PropTypes.bool,
            parentID: PropTypes.string,
          }),
        }),
      }),
    })
  ).isRequired,
  redirectUrl: PropTypes.string,
  match: PropTypes.shape({
    path: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
};

const TabRoute = ({
  baseUrl,
  resourcePath,
  tabTitle,
  perform,
  resourceName,
  data,
}) => {
  if (!perform) {
    return (
      <NavLink
        key={resourcePath}
        to={`${baseUrl}/${resourcePath}`}
        data-cy={`${resourceName}-${resourcePath}`}
      >
        {tabTitle}
      </NavLink>
    );
  }

  return (
    <HasPermission perform={perform} data={data}>
      <NavLink
        key={resourcePath}
        to={`${baseUrl}/${resourcePath}`}
        data-cy={`${resourceName}-${resourcePath}`}
      >
        {tabTitle}
      </NavLink>
    </HasPermission>
  );
};

TabRoute.defaultProps = {
  perform: "",
  resourceName: "",
  data: {},
};

TabRoute.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  resourcePath: PropTypes.string.isRequired,
  tabTitle: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  perform: PropTypes.string,
  resourceName: PropTypes.string,
  data: PropTypes.shape({}),
};

export { TabWithRoute, TabRoute };
